import React from "react";
import Nodes from "./Nodes";
import LanguageSelector from "./LanguageSelector";

const Dictionary: React.FC = () => {
  return (
    <>
      <h1>Dictionary</h1>
      <LanguageSelector />
      <Nodes />
    </>
  )
};

export default Dictionary;